import { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api.js";
import { useAuth } from "../context/AuthContext.jsx";
import AuthShell, { BotonPrimario, BotonSecundario } from "../components/AuthShell.jsx";

/**
 * VerifyEmail · v8.5.63 · piel — mismo marco de 3 estados que VerifyMagic
 * (comparten AuthShell); antes esta pantalla auto-redirigía con un
 * setTimeout de 1.5s tras "verificado" — ahora se detiene en "listo" con
 * un botón real, coherente con "nunca un salto silencioso" del resto de la piel.
 */
export default function VerifyEmail() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const [estado, setEstado] = useState("verificando");
  const [error, setError] = useState(null);
  const [clientes, setClientes] = useState([]);
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;
    const token = params.get("token");
    if (!token) { setError("Token faltante"); setEstado("vencido"); return; }
    (async () => {
      try {
        const r = await api.verifyEmail(token);
        await loginWithToken(r.session_token, r.user, r.clientes);
        setClientes(r.clientes || []);
        setEstado("listo");
      } catch (err) {
        setError(err.message);
        setEstado("vencido");
      }
    })();
  }, []);

  const entrar = () => navigate(clientes.length > 1 ? "/elegir-cliente" : "/", { replace: true });

  return (
    <AuthShell>
      {estado === "verificando" && (
        <p className="font-display text-[24px] leading-tight text-[var(--ink)] animate-pulse">Verificando tu email…</p>
      )}
      {estado === "listo" && (
        <>
          <h1 className="h1-portal text-[var(--done)]">Email verificado</h1>
          <p className="text-[15px] text-[var(--muted)] mt-2">Tu cuenta ya está activa — entrá al portal.</p>
          <div className="mt-6"><BotonPrimario type="button" onClick={entrar}>Entrar</BotonPrimario></div>
        </>
      )}
      {estado === "vencido" && (
        <>
          <h1 className="h1-portal text-[var(--danger)]">No pudimos verificar</h1>
          <p className="text-[15px] text-[var(--muted)] mt-2">{error}</p>
          <div className="mt-6"><BotonSecundario href="/login">Pedir uno nuevo</BotonSecundario></div>
        </>
      )}
    </AuthShell>
  );
}
